module.exports = __webpack_public_path__ + "static/media/h5_banner2.35185db8.png";